
const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Contacto inicial',
      description: 'Llámanos o escríbenos por WhatsApp. Te atendemos 24/7 para conocer tu situación y necesidades específicas.',
    },
    {
      number: '02',
      title: 'Visita y presupuesto',
      description: 'Realizamos una visita gratuita al inmueble para evaluar el trabajo necesario y ofrecerte un presupuesto detallado sin compromiso.',
    },
    {
      number: '03',
      title: 'Planificación',
      description: 'Acordamos contigo la fecha, horario y metodología de trabajo. Organizamos el equipo y los recursos necesarios.',
    },
    {
      number: '04',
      title: 'Ejecución',
      description: 'Nuestro equipo profesional realiza el vaciado, limpieza y servicios adicionales acordados con máxima eficiencia y discreción.',
    },
    {
      number: '05',
      title: 'Gestión de residuos',
      description: 'Nos encargamos de la retirada, transporte y gestión legal de todos los residuos, muebles y enseres.',
    },
    {
      number: '06',
      title: 'Entrega final',
      description: 'Realizamos una inspección final contigo para asegurar que todo está perfecto. Entregamos el inmueble listo para su uso.',
    },
  ];

  return (
    <section className="py-24 bg-silver-light/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-graphite mb-4">
            Nuestro <span className="text-primary">proceso de trabajo</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-2xl mx-auto">
            Un método probado y eficiente que garantiza resultados excepcionales en cada proyecto
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 shadow-card hover:shadow-card-hover transition-all h-full">
                <div className="text-6xl font-bold text-primary/20 mb-4">{step.number}</div>
                <h3 className="text-2xl font-bold text-graphite mb-3">{step.title}</h3>
                <p className="text-gray-dark leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-primary"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="tel:+34602365996"
            className="inline-flex items-center px-8 py-4 bg-primary text-white rounded-lg font-semibold text-lg hover:bg-primary-dark hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Solicita tu presupuesto gratis
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
